import React from 'react'

import Image from 'next/image'
import { StyledChefPeopleLogo } from './styles'

const ChefPeopleLogo = () => (
  <StyledChefPeopleLogo>
    <Image src={'/images/logo_chef_lovers.png'} width={72} height={72} alt='Chef Lovers' />
  </StyledChefPeopleLogo>
)

export default ChefPeopleLogo
